// Option definitions for the module config fields, shared by ModuleAddForm
// and ModuleEditForm. Values match the API schema types (models/Module.js):
//   ModeType  Number  0 BLE, 1 PUBLIC PIN, 2 PUBLIC RFID
//   Mode      String  'B' básico, 'C' carga
//   Wide      String  'N' normal, 'W' wide
//   Gender    String  '', 'M', 'F'
//   HardType  Number  2 pincho, 3 slide
//   Environment String 'indoor', 'outdoor'
//   Espressif Number  0..15

// Code prefix toggle: VLM = módulo, VLK = kiosco.
export const PREFIX_OPTIONS = [
  { value: 'VLM', label: 'VLM' },
  { value: 'VLK', label: 'VLK' },
];

export const MODE_TYPE_OPTIONS = [
  { value: 0, label: 'Bluetooth', icon: 'fa-bluetooth-b', fab: true },
  { value: 1, label: 'Public PIN', icon: 'fa-keyboard' },
  { value: 2, label: 'Public RFID', icon: 'fa-id-card' },
];

export const MODE_OPTIONS = [
  { value: 'B', label: 'Módulo básico', icon: 'fa-cube' },
  { value: 'C', label: 'Módulo de carga', icon: 'fa-bolt' },
];

export const WIDE_OPTIONS = [
  { value: 'N', label: 'Normal', icon: 'fa-square' },
  { value: 'W', label: 'Ampliado (Wide)', icon: 'fa-arrows-alt-h' },
];

export const HARDTYPE_OPTIONS = [
  { value: 2, label: 'Pincho', icon: 'fa-thumbtack' },
  { value: 3, label: 'Slide', icon: 'fa-grip-lines' },
];

export const GENDER_OPTIONS = [
  { value: '', label: 'Sin género', icon: 'fa-genderless' },
  { value: 'M', label: 'Masculino', icon: 'fa-mars' },
  { value: 'F', label: 'Femenino', icon: 'fa-venus' },
];

export const ENVIRONMENT_OPTIONS = [
  { value: 'indoor',  label: 'Interior', icon: 'fa-home' },
  { value: 'outdoor', label: 'Exterior', icon: 'fa-tree' },
];

export const ESPRESSIF_OPTIONS = [...Array(16).keys()].map((i) => ({
  value: i,
  label: String(i),
}));
